import barba from '@barba/core';
import { gsap } from "gsap";
// import { FormHandler } from './plugContactForm';
// → Barba遷移後にフォームを再初期化するためのクラス（必要に応じて利用）

export function initBarba(onPageTransition) {

  // ================================
  // pjax除外設定
  // → 特定のリンクはPJAX対象外にして通常遷移させる
  // ================================
  $('a[href*="/service/system-development/biz-sys/"]').addClass('no-pjax');
  $('a[href*="/tech-lab/algolia-trial/"]').addClass('no-pjax');

  // ================================
  // ページ遷移後の共通処理
  // ================================
  const handleAfterTransition = (data) => {
    if (data.current.url.path !== data.next.url.path) {
      if ($('.wpcf7-form').length) {
        location.reload();
        // → Contact Form 7 がある場合は正常動作のためリロードを強制
      }
    }
    onPageTransition(); // → ページ遷移ごとに呼びたい共通処理を実行
    window.scrollTo(0, 0); // → 遷移後は常にスクロール位置をトップへ

    // GTM のデータレイヤー更新（必要に応じて有効化）
    // dataLayer.push({
    //   'newPageUrl': location.pathname,
    //   event: 'pageLoaded'
    // });
  };

  // ================================
  // トランジションアニメーション設定
  // ================================
  const fadeTransition = {
    name: 'fade',
    leave: (data) => animateLeave(data.current.container), // → ページ離脱時のアニメーション
    enter: (data) => animateEnter(data.next.container),   // → ページ表示時のアニメーション
  };

  // ================================
  // アニメーション関数（再利用可能）
  // ================================
  const animateLeave = (container) => {
    return gsap.to(container, {
      opacity: 0,
      duration: 0.5, // → フェードアウト 0.5秒
    });
  };

  const animateEnter = (container) => {
    return gsap.from(container, {
      opacity: 0,
      duration: 0.5, // → フェードイン 0.5秒
    });
  };

  // ================================
  // Barba.js の初期化
  // ================================
  barba.hooks.after(handleAfterTransition);

  barba.init({
    prevent: ({ el }) => {
      const href = el.href;
      // → 特定のリンク（biz-sys配下 or no-pjaxクラス）は PJAX除外
      return href.includes('/system-development/biz-sys/') || href.includes('/tech-lab/algolia-trial/') || el.classList.contains('no-pjax');
    },
    transitions: [fadeTransition], // → 上記で定義したフェードアニメーションを適用
  });

  // ================================
  // 遷移直前の処理
  // ================================
  barba.hooks.before((data) => {
    const href = data.trigger?.href || window.location.href;

    // 戻る遷移のときに trigger がない場合 → current URL で判定
    if (
      href.includes('/system-development/biz-sys/') ||
      href.includes('/tech-lab/algolia-trial/') ||
      data.trigger?.classList?.contains('no-pjax')
    ) {
      // Barba をキャンセルして通常遷移にフォールバック
      window.location.href = href;
    }
  });

  // ================================
  // ページ遷移後にフォームの再初期化
  // ================================
  barba.hooks.afterEnter(() => {
    // new FormHandler();
    // → フォームを再初期化する場合に有効化
  });
}
